import { useTranslation } from 'react-i18next';

import { IManufacturer } from '../../../../../../PcfWizard.type';

type MenuProps = {
  filteredManufacturers: IManufacturer[];
  onItemSelect: (item: IManufacturer) => void;
  onItemMouseDown: (e: React.MouseEvent<HTMLElement>) => void;
};

const Menu = ({ filteredManufacturers, onItemMouseDown, onItemSelect }: MenuProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <div className='relative' onMouseDown={onItemMouseDown}>
      <div className='p-dropdown-panel p-component p-ripple-disabled p-connected-overlay-enter-done z-2 absolute w-full overflow-auto'>
        <div className='p-dropdown-items-wrapper max-h-15rem'>
          <ul className='p-dropdown-items'>
            {filteredManufacturers.length > 0 ? (
              <>
                {filteredManufacturers?.map((manufacturer, index) => {
                  return (
                    <li
                      key={manufacturer.id || index}
                      className='p-dropdown-item'
                      onClick={(): void => {
                        return onItemSelect(manufacturer);
                      }}
                    >
                      <span>{manufacturer?.name}</span>
                    </li>
                  );
                })}
              </>
            ) : (
              <li className='p-dropdown-item cursor-auto'>
                <div className='flex w-full'>
                  <span>
                    {t(
                      'footprintDetailsPage.sections.calculatePcfSection.injectionMoldingSection.noManufacturerFound',
                    )}
                  </span>
                </div>
              </li>
            )}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Menu;
